module.exports = __webpack_public_path__ + "static/img/9.1b4fca3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/9.png
// module id = Zxm6
// module chunks = 0